//
// Consent management.
function AdsNinjaConsentManager(logger){

    this.__consentKnown = false;
    this.__logger       = logger;
    this.__initialized  = false;
    this.__queue        = [];
}

//
// Returns true when consent is known.
AdsNinjaConsentManager.prototype.getIsConsentKnown = function(){

    return this.__consentKnown;
}

//
// Sets consent is known.
AdsNinjaConsentManager.prototype.setIsConsentKnown = function(value){

    this.__consentKnown = value;
}

//
// Sets consent is known.
AdsNinjaConsentManager.prototype.getLogger = function(){

    return this.__logger;
}

//
// Attach Sourcepoint CMP modal links
AdsNinjaConsentManager.prototype.attachSPLinks = function(applicableConsentData){

    if (applicableConsentData) {
        // Inject sourcepoint footer link
        var pmLink = document.createElement('a');
        pmLink.id = 'pmLink';
        pmLink.style.visibility = "hidden";
        pmLink.className = 'text';
        var ccpaLink = document.getElementById('ccpa-link');
        if (ccpaLink) {
            ccpaLink.appendChild(pmLink);
        }

        var pmLink = document.getElementById('pmLink');
        if (pmLink) {
          if (applicableConsentData.message_type === "usnat") {
            pmLink.style.visibility = "visible";
            pmLink.textContent = "Do Not Sell or Share My Personal Information";
            pmLink.onclick = function () {
              window._sp_?.usnat.loadPrivacyManagerModal('');
            };
          } else if (applicableConsentData.message_type === "gdpr") {
            pmLink.style.visibility = "visible";
            pmLink.textContent = "Manage Cookies";
            pmLink.onclick = function () {
              window._sp_?.gdpr.loadPrivacyManagerModal('');
            };
          }
        }
    }
}

//
// Waits for consent to be known.
AdsNinjaConsentManager.prototype.waitForConsent = function(callback){
    var usingSourcepoint = true;

    if(!this.__initialized){

        if (usingSourcepoint) {
          this.setupSP();
        } else {
          this.__setupCmp();
        }

        this.__initialized = true;
    }

    if(typeof callback !== 'function'){

        return;
    }

    if(this.__consentKnown){

        callback();
    }
    else{
        
        this.__queue.push(callback);
    }

    if (usingSourcepoint && window.spConsentKnown) {
        window.spConsentKnown.then((applicableConsentData) => {
            if (applicableConsentData) {
              this.__setGtagConsent(applicableConsentData.message_type)
            }

            this.setIsConsentKnown(true);
            this.processQueue();
        })
    }

};

//
// Sets up Sourcepoint.
AdsNinjaConsentManager.prototype.setupSP = function(){
    var self = this;
    if (!this.__initialized && window.spConsentKnown) {
        this.__initialized = true;

        window.spConsentKnown.then((applicableConsentData) => {
            self.attachSPLinks(applicableConsentData);

            // Event listener for when user updates consent preferences.
            window._sp_.addEventListener('onConsentReady', function(message_type, _uuid, _string, info) {
                self.__setGtagConsent(message_type);
            })
        })

    }
}

//
// Sets up CMP.
AdsNinjaConsentManager.prototype.__setupCmp = function(){

    // Admiral CMP tool callback.
    // Make sure that the properties exist on the window.
    window.admiral = window.admiral || function(){(admiral.q = admiral.q || []).push(arguments)};

    this.__consentNeeded = true;
    var self             = this;
    var consentCallback  = function(consentInfo){

        self.getLogger().info('CMP loaded or updated!', {
            data: consentInfo,
        });

        if(consentInfo.consentKnown){

            self.getLogger().info(`Consent is known.`, {
                data: consentInfo,
            });

            self.setIsConsentKnown(true);


            self.processQueue();
        }
    };

    // Test GA4 enhanced consent mode on PN & FFC
    consentCallback = function(consentInfo) {
        self.getLogger().info('CMP loaded or updated!', { data: consentInfo });

        if (consentInfo.consentKnown) {
            self.getLogger().info(`Consent is known.`, { data: consentInfo });

            self.setIsConsentKnown(true);
            self.processQueue();

            var tcData = consentInfo.tcData || {};
            var purposes = tcData.purpose?.consents || {};


            if (window.adsNinjaHeaderBiddingManager.getGeo() === 'GB') {
              var granted = (purposeId) => purposes[purposeId] === true ? 'granted' : 'denied';

              window.gtag?.('consent', 'update', {
                ad_storage: granted('1'), // Uses Admiral purpose mappings
                analytics_storage: granted('7'),
                ad_user_data: granted('1'),
                ad_personalization: granted('4'),
                security_storage: 'granted'
              });
            }
        }
    };
    // If Admiral CMP is not on page this will not be called.
    window.admiral('after', 'cmp.loaded', consentCallback);
    window.admiral('after', 'cmp.updated', consentCallback);
};

//
// Sets gtag consent values as all granted
AdsNinjaConsentManager.prototype.__setGtagConsentGrantAll = function(){
    window.gtag?.('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      security_storage: 'granted',
    });
}

//
// Sets gtag consent values for GA4, for the UK
AdsNinjaConsentManager.prototype.__setGtagConsent = function(messageType){

    if (messageType === "gdpr") {

        window.__tcfapi('getTCData', 2, function(tcData, success) {
          if (success) {
            console.log("TCF Data: ", tcData);
            var consents = tcData?.purpose?.consents || {};

            window.googletag.cmd.push(function(){

                window.googletag.pubads().setTargeting('Consent', (consents[1]) ? '1' : '0');            
            });

            if (window.adsNinjaHeaderBiddingManager.getGeo() === 'GB') {
              window.gtag?.('consent', 'update', {
                ad_storage: consents[1] ? 'granted' : 'denied',
                analytics_storage: consents[7] ? 'granted' : 'denied',
                ad_user_data: consents[1] ? 'granted' : 'denied',
                ad_personalization: consents[4] ? 'granted' : 'denied',
                security_storage: 'granted'
              });
            }
          }
        });
    }

    if (messageType === "usnat") {
        var consent = 'granted';

        // Get GPP Data 
        window.__gpp?.("ping", function (evt) {
            var saleOptOut = evt?.parsedSections?.ustx?.SaleOptOut;
            if (saleOptOut === 1) {
              consent = 'denied'
            }

            window.googletag.cmd.push(function(){

                window.googletag.pubads().setTargeting('Consent', (consent === 'granted') ? '1' : '0');            
            });

            if (window.adsNinjaHeaderBiddingManager.getGeo() === 'GB') {
              window.gtag?.('consent', 'update', {
                ad_storage: consent,
                analytics_storage: consent,
                ad_user_data: consent,
                ad_personalization: consent,
                security_storage: consent
              });
            }
        });
    }
}

//
// Process queue of closures.
AdsNinjaConsentManager.prototype.processQueue = function(){

    // Execute all closures currently in the queue.
    while(this.__queue.length > 0){

        var closure = this.__queue.shift();

        try{

            closure();
        }
        catch(error){

            this.logger.error('Error encountered while processing queue.', {
                message: error.message,
                closure: closure,
            });
        }
    }
};

window.AdsNinjaConsentManager = AdsNinjaConsentManager;
